









































































































import mixins from 'vue-typed-mixins';

import SingleSubmissionPmselect from '@/components/home/pmAssignment/SingleSubmissionPmselect.vue';
import BasePmselect from '@/components/home/pmAssignment/BasePmselect.vue';
import OutdatedAssignmentWarningRadio from '@/components/home/pmAssignment/OutdatedAssignmentWarningRadio.vue';
import SingleSubmissionInfo from '@/components/home/pmAssignment/SingleSubmissionInfo.vue';
import UserPicker from '@/components/shared/UserPicker.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import AssignSelectedButton from '@/components/shared/AssignSelectedButton.vue';
import CompassInlineMessage from '@/components/compass/CompassInlineMessage.vue';

import { SubmissionRecord } from '@/interfaces/SubmissionRecord';
import { User, SubconnectUser } from '@/interfaces/User';
import { SubmissionLanguage } from '@/interfaces/SubmissionLanguage';
import { LanguagePmList } from '@/interfaces/Pmselect';
import { AssignModeEnum } from '@/interfaces/Assignment';

import userQueryMixin from '@/mixins/userQuery.mixin';
import submissionPmModalMixin from '@/mixins/submissionPmModal.mixin';
import projectAUpdatesMixin from '@/mixins/pmAssignment/projectAUpdates.mixin';

export default mixins(userQueryMixin, submissionPmModalMixin, projectAUpdatesMixin).extend({
  name: 'SingleSubmissionPmModal',
  data() {
    return {
      assignMode: AssignModeEnum.EACH_SUBMISSION,

      languagePairsCheckedList: [] as boolean[],
      selectAllPairs: false,
      showUserPicker: false,
    };
  },
  components: {
    UserPicker,
    SingleSubmissionPmselect,
    BasePmselect,
    OutdatedAssignmentWarningRadio,
    SingleSubmissionInfo,
    LoadingSpinner,
    AssignSelectedButton,
    CompassInlineMessage,
  },
  computed: {
    finalDueString(): string {
      // TODO: Add day of week to formatting here
      const finalDue = this.submission.finalDue || '';
      const momentDateObj = this.$moment.utc();
      let dateString = '';
      if (momentDateObj.isValid()) {
        dateString = momentDateObj.local().format('MM/DD/YYYY');
        const now = new Date();
        const diff = Number(new Date(finalDue)) - Number(now);
        if (diff > 0) {
          dateString += ` (${momentDateObj.fromNow(true)})`;
        }
      }
      return dateString;
    },
    appId(): string | null | undefined {
      return this.submission.appId;
    },
    submission(): SubmissionRecord {
      return this.submissionList[0];
    },
    languagePairList(): SubmissionLanguage[] {
      return this.submission.languages;
    },
    languagePairsPmList: {
      get(): LanguagePmList[] {
        return this.submissionsPmList[0];
      },
      set(pmList: LanguagePmList[]): void {
        this.submissionsPmList = [pmList];
      },
    },
    showWorkstreamsWarning(): boolean {
      return !!this.$route.matched.find((route) => route.name === 'detailsSummary');
    },
  },
  async created(): Promise<void> {
    await this.onPmModalCreated();
    this.languagePairsCheckedList = this.submissionList[0].languages.map(() => false);
  },
  methods: {
    clearAll(): void {
      this.languagePairsPmList = this.languagePairsPmList.map(() => []);
    },
    isChecked(languagePairId: number): boolean {
      const lpIdx = this.findIndexOfLanguagePairList(languagePairId);
      return this.languagePairsCheckedList[lpIdx];
    },
    findIndexOfLanguagePairList(languagePairId: number) {
      return this.languagePairList
        .findIndex((lp) => lp.languagePairId === languagePairId);
    },
    bindSelectedUsers(userList: (SubconnectUser | User)[]): void {
      // user-picker is capable of emitting both idp users and subconnect users
      const selectedPms = this.usersToPms(userList);
      this.languagePairsPmList = this.languagePairList
        .map((lp) => (this.isChecked(lp.languagePairId)
          ? this.$lodash(this.getLpPms(lp.languagePairId))
            .concat(selectedPms)
            .uniqBy((pm) => pm.email)
            .value()
          : this.getLpPms(lp.languagePairId)));
    },
  },
  watch: {
    selectAllPairs(newVal) {
      this.languagePairsCheckedList.fill(newVal);
    },
  },
});
